import React from 'react';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getFilterTooltip } from './filterTooltips';

// Filter components
import AiLabelsSection from '../filters/AiLabelsSection';
import AiLabelsSection2 from '../filters/AiLabelsSection2';
import AppsSection from '../filters/AppsSection';
import AuthorIdsSection from '../filters/AuthorIdsSection';
import BeaconScoresSection from '../filters/BeaconScoresSection';
import BlacklistSection from '../filters/BlacklistSection';
import BooleanFiltersSection from '../filters/BooleanFiltersSection';
import BoostWalletLabelsSection from '../filters/BoostWalletLabelsSection';
import BoostWalletTagsSection from '../filters/BoostWalletTagsSection';
import ChannelsSection from '../filters/ChannelsSection';
import CoinLabelsSection from '../filters/CoinLabelsSection';
import CustomJsonFilterSection from '../filters/CustomJsonFilterSection';
import DatesRangeSection from '../filters/DatesRangeSection';
import DateRangeSection from '../filters/DateRangeSection';
import DomainsSection from '../filters/DomainsSection';
import IsNullSection from '../filters/IsNullSection';
import ItemIdsSection from '../filters/ItemIdsSection';
import ItemFeaturesSection from '../filters/ItemFeaturesSection';
import KeywordSection from '../filters/KeywordSection';
import KeywordsSection from '../filters/KeywordsSection';
import LanguageSection from '../filters/LanguageSection';
import LocationSection from '../filters/LocationSection';
import MediaContentTypesSection from '../filters/MediaContentTypesSection';
import MiniappsSection from '../filters/MiniappsSection';
import NumericFiltersSection from '../filters/NumericFiltersSection';
import PublicationTypeSection from '../filters/PublicationTypeSection';
import SocialMetricsSection from '../filters/SocialMetricsSection';
import SpamModerationSection from '../filters/SpamModerationSection';
import TagsSection from '../filters/TagsSection';
import TagsSection2 from '../filters/TagsSection2';
import InAppUsersSection from '../filters/InAppUsersSection';
import ConsoleAccountSection from '../filters/ConsoleAccountSection';
import UserFollowedBySection from '../filters/UserFollowedBySection';
import UserIdsSection from '../filters/UserIdsSection';
import VideoSection from '../filters/VideoSection';
import WalletPreferencesSection1 from '../filters/WalletPreferencesSection1';
import FarcasterPreferencesSection from '../filters/FarcasterPreferencesSection';
import TokenIdentifiersSection from '../filters/TokenIdentifiersSection';
import ChainSection from '../filters/ChainSection';

import ZoraAuthorSection from '../filters/ZoraAuthorSection';
import ZoraMarketInfoSection from '../filters/ZoraMarketInfoSection';


const FilterTypeRouter = ({ filterType, boostInput, onUpdate, source }) => {
  if (!filterType) {
    return null;
  }

  const standardFilter = () => {
    switch (filterType) {
      case 'publication_types':
        return <PublicationTypeSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'media_content_types':
        return <MediaContentTypesSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'ai_labels':
        return <AiLabelsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'ai_labels2':
        return <AiLabelsSection2 boostInput={boostInput} onUpdate={onUpdate} />;
      case 'spam_moderation':
        return <SpamModerationSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'channels':
        return <ChannelsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'item_ids':
        return <ItemIdsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'coin_labels':
        return <CoinLabelsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'apps':
        return <AppsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'languages':
        return <LanguageSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'locations':
        return <LocationSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'miniapps':
        return <MiniappsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'video':
        return <VideoSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'tags':
        return <TagsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'tags2':
        return <TagsSection2 boostInput={boostInput} onUpdate={onUpdate} />;
      case 'custom_json':
        return <CustomJsonFilterSection boostInput={boostInput} onUpdate={onUpdate} />;
      default:
        return null;
    }
  }


  const farcasterItemsFilter = () => {
    switch (filterType) {
      case 'date':
        return <DateRangeSection boostInput={boostInput} onUpdate={onUpdate} field="item_creation_timestamp" />;
      case 'keywords':
        return <KeywordSection boostInput={boostInput} onUpdate={onUpdate} fieldKey="text_enriched" />;
      case 'item_features':
        return <ItemFeaturesSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'social_filters':
        return <SocialMetricsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'beacon_models':
        return <BeaconScoresSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'user_preferences':
        return <FarcasterPreferencesSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'blacklist':
        return <BlacklistSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'domains':
        return <DomainsSection boostInput={boostInput} onUpdate={onUpdate} fieldName="domains" />;
      case 'authors':
        return <AuthorIdsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'author_followed_by':
        return <UserFollowedBySection boostInput={boostInput} onUpdate={onUpdate} fieldName="user_id" />;
      default:
        return null;
    }
  }


  const zoraCoinsFilter = () => {
    switch (filterType) {
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'zora_created_at', label: 'Creation Date' },
          { id: 'zora_updated_at', label: 'Last Update' },
          { id: 'last_interaction_timestamp', label: 'Last Interaction' }
        ]} />;
      case 'keywords':
        return <KeywordsSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { id: 'zora_name', label: 'Coin Name' },
          { id: 'zora_description', label: 'Description' }
        ]} />;
      case 'domains':
        return <DomainsSection boostInput={boostInput} onUpdate={onUpdate} fieldName="domain" />;
      case 'authors':
        return <ZoraAuthorSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'author_followed_by':
        return <UserFollowedBySection boostInput={boostInput} onUpdate={onUpdate} fieldName="zora_creator_farcaster_id" />;
      case 'boolean_filters':
        return <BooleanFiltersSection boostInput={boostInput} onUpdate={onUpdate} booleanFieldOptions={[
          { id: 'active', label: 'Active' }
        ]} />;
      case 'is_null':
        return <IsNullSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { value: 'zora_media_content_type', label: 'Media Content Type' },
          { value: 'zora_creator_farcaster_id', label: 'Creator Farcaster ID' }
        ]} />;
      case 'market_info':
        return <ZoraMarketInfoSection boostInput={boostInput} onUpdate={onUpdate} />;
      default:
        return null;
    }
  }


  const polymarketItemsFilter = () => {
    switch (filterType) {
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'start_date', label: 'Start Date' },
          { id: 'end_date', label: 'End Date' },
          { id: 'game_start_time', label: 'Game Start Time' }
        ]} />;
      case 'boolean_filters':
        return <BooleanFiltersSection boostInput={boostInput} onUpdate={onUpdate} booleanFieldOptions={[
          { id: 'featured', label: 'featured' },
          { id: 'restricted', label: 'restricted' },
          { id: 'closed', label: 'closed' },
          { id: 'price_under05_or_over95', label: 'price_under05_or_over95' },
          { id: 'price_0_or_1', label: 'price_0_or_1' },
        ]} />;
      case 'keywords':
        return <KeywordsSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { id: 'question', label: 'Question' },
          { id: 'description', label: 'Description' }
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'liquidity', label: 'liquidity', type: 'decimal' },
          { id: 'one_day_price_change', label: 'one_day_price_change', type: 'decimal' },
          { id: 'one_day_price_change_abs', label: 'one_day_price_change_abs', type: 'decimal' },
          { id: 'one_hour_price_change', label: 'one_hour_price_change', type: 'decimal' },
          { id: 'one_hour_price_change_abs', label: 'one_hour_price_change_abs', type: 'decimal' },
          { id: 'one_month_price_change', label: 'one_month_price_change', type: 'decimal' },
          { id: 'one_month_price_change_abs', label: 'one_month_price_change_abs', type: 'decimal' },
          { id: 'one_week_price_change', label: 'one_week_price_change', type: 'decimal' },
          { id: 'one_week_price_change_abs', label: 'one_week_price_change_abs', type: 'decimal' },
          { id: 'volume', label: 'volume', type: 'decimal' },
          { id: 'volume_1mo', label: 'volume_1mo', type: 'decimal' },
          { id: 'volume_1wk', label: 'volume_1wk', type: 'decimal' },
          { id: 'volume_1yr', label: 'volume_1yr', type: 'decimal' },
          { id: 'volume_24hr', label: 'volume_24hr', type: 'decimal' },
          { id: 'span_days', label: 'span_days', type: 'integer' },
        ]} />;
      case 'wallet_prefs1':
        return <WalletPreferencesSection1 boostInput={boostInput} onUpdate={onUpdate} />;
      case 'boost_wallet_labels':
        return <BoostWalletLabelsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'boost_wallet_tags':
        return <BoostWalletTagsSection onUpdate={onUpdate} />;
      default:
        return null;
    }
  }

  const polymarketWalletsFilter = () => {
    switch (filterType) {
      case 'user_ids':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['user_id', 'name', 'pseudonym']} />;
      case 'is_null':
        return <IsNullSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { value: 'name', label: 'Name' },
          { value: 'pseudonym', label: 'Pseudonym' },
          { value: 'pfp', label: 'PFP' },
          { value: 'primary_labels', label: 'Primary Labels' },
          { value: 'secondary_labels', label: 'Secondary Labels' },
          { value: 'primary_similar_wallets', label: 'Primary Similar Wallets' },
          { value: 'secondary_similar_wallets', label: 'Secondary Similar Wallets' },
          { value: 'text_vector', label: 'Text Vector' }
        ]} />;
      case 'date':
        return <DateRangeSection boostInput={boostInput} onUpdate={onUpdate} field="updated_at" />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'volume', label: 'volume', type: 'decimal' },
          { id: 'pnl', label: 'pnl', type: 'decimal' },
          { id: 'events_per_day', label: 'events_per_day', type: 'integer' }
        ]} />;
      case 'author_in_app_users':
        return (
          <>
            <InAppUsersSection boostInput={boostInput} onUpdate={onUpdate} fieldName="user_id" />
            <ConsoleAccountSection boostInput={boostInput} onUpdate={onUpdate} fieldName="user_id" />
          </>
        );
      default:
        return null;
    }
  }

  const kalshiItemsFilter = () => {
    switch (filterType) {
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'start_date', label: 'Start Date' },
          { id: 'end_date', label: 'End Date' },
          { id: 'created_at', label: 'Created At' },
          { id: 'updated_at', label: 'Updated At' }
        ]} />;
      case 'boolean_filters':
        return <BooleanFiltersSection boostInput={boostInput} onUpdate={onUpdate} booleanFieldOptions={[
          { id: 'active', label: 'active' },
          { id: 'closed', label: 'closed' }
        ]} />;
      case 'keywords':
        return <KeywordsSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { id: 'question', label: 'Question' },
          { id: 'description', label: 'Description' }
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'volume', label: 'volume', type: 'decimal' }
        ]} />;
      case 'tags':
        return <TagsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'boost_wallet_labels':
        return <BoostWalletLabelsSection boostInput={boostInput} onUpdate={onUpdate} lookupIndex="kalshi-wallets" />;
      case 'boost_wallet_tags':
        return <BoostWalletTagsSection onUpdate={onUpdate} lookupIndex="kalshi-wallets" />;
      default:
        return null;
    }
  }

  const kalshiWalletsFilter = () => {
    switch (filterType) {
      case 'user_ids':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['user_id']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'updated_at', label: 'Updated At' },
          { id: 'last_trade_time', label: 'Last Trade Time' }
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'pnl', label: 'pnl', type: 'decimal' },
          { id: 'volume_quote', label: 'volume_quote', type: 'decimal' },
          { id: 'volume_outcome', label: 'volume_outcome', type: 'decimal' },
          { id: 'markets_traded', label: 'markets_traded', type: 'integer' },
          { id: 'events_per_day', label: 'events_per_day', type: 'decimal' }
        ]} />;
      case 'is_null':
        return <IsNullSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { value: 'primary_labels', label: 'Primary Labels' },
          { value: 'secondary_labels', label: 'Secondary Labels' },
          { value: 'primary_tags', label: 'Primary Tags' },
          { value: 'secondary_tags', label: 'Secondary Tags' },
          { value: 'protocol', label: 'Protocol' },
          { value: 'ai_labels', label: 'AI Labels' }
        ]} />;
      default:
        return null;
    }
  }

  const farcasterUsersFilter = () => {
    switch (filterType) {
      case 'user_ids':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['user_id']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'updated_at', label: 'Updated At' },
          { id: 'full_update_timestamp', label: 'Full Update Timestamp' },
          { id: 'soft_update_timestamp', label: 'Soft Update Timestamp' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'events_per_day', label: 'events_per_day', type: 'decimal' },
          { id: 'events_since_full_update', label: 'events_since_full_update', type: 'integer' },
          { id: 'score_spam', label: 'score_spam', type: 'decimal' },
          { id: 'score_not_ok', label: 'score_not_ok', type: 'decimal' },
          { id: 'score_like', label: 'score_like', type: 'decimal' },
          { id: 'score_comment', label: 'score_comment', type: 'decimal' },
          { id: 'score_share', label: 'score_share', type: 'decimal' },
          { id: 'score_reaction', label: 'score_reaction', type: 'decimal' },
        ]} />;
      case 'is_null':
        return <IsNullSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { value: 'primary_labels', label: 'Primary Labels' },
          { value: 'secondary_labels', label: 'Secondary Labels' },
          { value: 'primary_clusters', label: 'Primary Clusters' },
          { value: 'secondary_clusters', label: 'Secondary Clusters' },
          { value: 'ai_labels', label: 'AI Labels' },
          { value: 'cluster_ids', label: 'Cluster IDs' },
          { value: 'following_user_ids', label: 'Following User IDs' },
          { value: 'protocol', label: 'Protocol' },
        ]} />;
      default:
        return null;
    }
  }

  const tokenItemsFilter = () => {
    switch (filterType) {
      case 'date':
        return <DateRangeSection boostInput={boostInput} onUpdate={onUpdate} field="last_updated" />;
      case 'keywords':
        return <KeywordsSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { id: 'name', label: 'Token Name' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'market_cap', label: 'market_cap', type: 'decimal' },
          { id: 'price_usd', label: 'price_usd', type: 'decimal' },
          { id: 'price_diff_pct_1d', label: 'price_diff_pct_1d', type: 'decimal' },
          { id: 'volume_usd_1h', label: 'volume_usd_1h', type: 'decimal' },
          { id: 'volume_usd_24h', label: 'volume_usd_24h', type: 'decimal' },
          { id: 'circulating_supply', label: 'circulating_supply', type: 'decimal' },
          { id: 'decimals', label: 'decimals', type: 'integer' },
        ]} />;
      case 'token_identifiers':
        return <TokenIdentifiersSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'chain':
        return <ChainSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'item_ids':
        return <ItemIdsSection boostInput={boostInput} onUpdate={onUpdate} />;
      default:
        return null;
    }
  }

  const walletUsersFilter = () => {
    switch (filterType) {
      case 'user_ids':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['wallet_address', 'chains', 'labels', 'tags', 'fungible_positions_tokens_list']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'last_trade_timestamp', label: 'Last Trade Timestamp' },
          { id: 'zerion_last_enriched_at', label: 'Last Enriched At' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'allocation_cash_pct', label: 'allocation_cash_pct', type: 'decimal' },
          { id: 'allocation_fungibles_pct', label: 'allocation_fungibles_pct', type: 'decimal' },
          { id: 'allocation_nfts_pct', label: 'allocation_nfts_pct', type: 'decimal' },
          { id: 'num_trades_24h', label: 'num_trades_24h', type: 'integer' },
          { id: 'num_trades_30d', label: 'num_trades_30d', type: 'integer' },
          { id: 'pnl_net_invested_usd', label: 'pnl_net_invested_usd', type: 'decimal' },
          { id: 'pnl_pct_total', label: 'pnl_pct_total', type: 'decimal' },
          { id: 'pnl_realized_usd', label: 'pnl_realized_usd', type: 'decimal' },
          { id: 'pnl_unrealized_usd', label: 'pnl_unrealized_usd', type: 'decimal' },
          { id: 'portfolio_cash_usd', label: 'portfolio_cash_usd', type: 'decimal' },
          { id: 'portfolio_fungibles_usd', label: 'portfolio_fungibles_usd', type: 'decimal' },
          { id: 'portfolio_nfts_usd', label: 'portfolio_nfts_usd', type: 'decimal' },
          { id: 'portfolio_total_usd', label: 'portfolio_total_usd', type: 'decimal' },
          { id: 'volume_usd_24h', label: 'volume_usd_24h', type: 'decimal' },
          { id: 'volume_usd_7d', label: 'volume_usd_7d', type: 'decimal' },
          { id: 'volume_usd_30d', label: 'volume_usd_30d', type: 'decimal' },
        ]} />;
      case 'author_in_app_users':
        return (
          <>
            <InAppUsersSection boostInput={boostInput} onUpdate={onUpdate} fieldName="wallet_address" />
            <ConsoleAccountSection boostInput={boostInput} onUpdate={onUpdate} fieldName="wallet_address" />
          </>
        );
      default:
        return null;
    }
  }

  const notificationHyperliquidWalletsFilter = () => {
    switch (filterType) {
      case 'user_ids':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['wallet_address', 'chain', 'unique_tokens']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'last_trade_time', label: 'Last Trade Time' },
          { id: 'first_trade_time', label: 'First Trade Time' },
          { id: 'updated_at', label: 'Updated At' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'net_pnl_usd', label: 'net_pnl_usd', type: 'decimal' },
          { id: 'realized_pnl_usd', label: 'realized_pnl_usd', type: 'decimal' },
          { id: 'total_buy_volume_usd', label: 'total_buy_volume_usd', type: 'decimal' },
          { id: 'total_sell_volume_usd', label: 'total_sell_volume_usd', type: 'decimal' },
          { id: 'avg_trade_size_usd', label: 'avg_trade_size_usd', type: 'decimal' },
          { id: 'largest_trade_usd', label: 'largest_trade_usd', type: 'decimal' },
          { id: 'trade_count', label: 'trade_count', type: 'integer' },
          { id: 'buy_count', label: 'buy_count', type: 'integer' },
          { id: 'sell_count', label: 'sell_count', type: 'integer' },
          { id: 'tokens_traded', label: 'tokens_traded', type: 'integer' },
          { id: 'win_rate', label: 'win_rate', type: 'decimal' },
          { id: 'true_win_rate', label: 'true_win_rate', type: 'decimal' },
          { id: 'winning_positions', label: 'winning_positions', type: 'integer' },
          { id: 'closed_positions', label: 'closed_positions', type: 'integer' },
        ]} />;
      case 'author_in_app_users':
        return (
          <>
            <InAppUsersSection boostInput={boostInput} onUpdate={onUpdate} fieldName="wallet_address" />
            <ConsoleAccountSection boostInput={boostInput} onUpdate={onUpdate} fieldName="wallet_address" />
          </>
        );
      default:
        return null;
    }
  }

  const notificationHyperliquidPositionsFilter = () => {
    switch (filterType) {
      case 'user_ids':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['wallet_address', 'token_address', 'chain']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'last_trade_time', label: 'Last Trade Time' },
          { id: 'first_trade_time', label: 'First Trade Time' },
          { id: 'updated_at', label: 'Updated At' },
        ]} />;
      case 'boolean_filters':
        return <BooleanFiltersSection boostInput={boostInput} onUpdate={onUpdate} booleanFieldOptions={[
          { id: 'is_closed', label: 'is_closed' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'realized_pnl_usd', label: 'realized_pnl_usd', type: 'decimal' },
          { id: 'total_bought_usd', label: 'total_bought_usd', type: 'decimal' },
          { id: 'total_sold_usd', label: 'total_sold_usd', type: 'decimal' },
          { id: 'total_bought_qty', label: 'total_bought_qty', type: 'decimal' },
          { id: 'total_sold_qty', label: 'total_sold_qty', type: 'decimal' },
          { id: 'avg_cost_basis_usd', label: 'avg_cost_basis_usd', type: 'decimal' },
          { id: 'remaining_qty', label: 'remaining_qty', type: 'decimal' },
          { id: 'buy_count', label: 'buy_count', type: 'integer' },
          { id: 'sell_count', label: 'sell_count', type: 'integer' },
        ]} />;
      default:
        return null;
    }
  }

  const hyperliquidMarketsFilter = () => {
    switch (filterType) {
      case 'item_ids':
        return <ItemIdsSection boostInput={boostInput} onUpdate={onUpdate} />;
      case 'market_filters':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['raw_coin', 'normalized_coin', 'coin_namespace', 'asset_class', 'network', 'metadata_source', 'market_category']} />;
      case 'date':
        return <DateRangeSection boostInput={boostInput} onUpdate={onUpdate} field="updated_at" />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'all_mids_price', label: 'all_mids_price', type: 'decimal' },
        ]} />;
      default:
        return null;
    }
  }

  const hyperliquidItemsFilter = () => {
    switch (filterType) {
      case 'item_ids':
        return <ItemIdsSection boostInput={boostInput} onUpdate={onUpdate} field="transaction_hash" />;
      case 'trade_filters':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['wallet_address', 'token_address', 'token_symbol', 'direction', 'chain', 'transaction_hash']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'timestamp', label: 'Trade Time (epoch s)' },
          { id: 'indexed_at', label: 'Indexed At (epoch s)' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'size_usd', label: 'size_usd', type: 'decimal' },
          { id: 'price_usd', label: 'price_usd', type: 'decimal' },
          { id: 'token_bought_amount', label: 'token_bought_amount', type: 'decimal' },
          { id: 'token_sold_amount', label: 'token_sold_amount', type: 'decimal' },
          { id: 'holders_count', label: 'holders_count', type: 'integer' },
          { id: 'volume_usd_24h', label: 'volume_usd_24h', type: 'decimal' },
          { id: 'price_diff_pct_1d', label: 'price_diff_pct_1d', type: 'decimal' },
        ]} />;
      case 'author_in_app_users':
        return (
          <>
            <InAppUsersSection boostInput={boostInput} onUpdate={onUpdate} fieldName="wallet_address" />
            <ConsoleAccountSection boostInput={boostInput} onUpdate={onUpdate} fieldName="wallet_address" />
          </>
        );
      default:
        return null;
    }
  }

  const alphaNotificationsFilter = () => {
    switch (filterType) {
      case 'item_ids':
        return <ItemIdsSection boostInput={boostInput} onUpdate={onUpdate} field="signal_id" />;
      case 'notification_filters':
        return <UserIdsSection boostInput={boostInput} onUpdate={onUpdate} fields={['notification_type', 'signal_type', 'priority', 'chain']} />;
      case 'date':
        return <DatesRangeSection boostInput={boostInput} onUpdate={onUpdate} dateFieldOptions={[
          { id: 'timestamp', label: 'Triggered At' },
          { id: 'created_at', label: 'Created At' },
        ]} />;
      case 'numeric_filters':
        return <NumericFiltersSection boostInput={boostInput} onUpdate={onUpdate} metricOptions={[
          { id: 'total_usd_inflow', label: 'total_usd_inflow', type: 'decimal' },
          { id: 'trader_count', label: 'trader_count', type: 'integer' },
          { id: 'highest_rank', label: 'highest_rank', type: 'integer' },
          { id: 'token_price_usd', label: 'token_price_usd', type: 'decimal' },
          { id: 'token_price_change_pct', label: 'token_price_change_pct', type: 'decimal' },
          { id: 'token_holder_count', label: 'token_holder_count', type: 'integer' },
          { id: 'volume_24h_usd', label: 'volume_24h_usd', type: 'decimal' },
        ]} />;
      case 'keywords':
        return <KeywordsSection boostInput={boostInput} onUpdate={onUpdate} fieldOptions={[
          { id: 'headline', label: 'Headline' },
          { id: 'token_symbol', label: 'Token Symbol' },
          { id: 'market_question', label: 'Market Question' },
          { id: 'why_reasons', label: 'Why Reasons' },
        ]} />;
      default:
        return null;
    }
  }

  let filterComponent = standardFilter();
  if (!filterComponent) {
    if (source === 'farcaster-items') {
      filterComponent = farcasterItemsFilter();
    } else if (source === 'zora-coins') {
      filterComponent = zoraCoinsFilter();
    } else if (source === 'polymarket-items') {
      filterComponent = polymarketItemsFilter();
    } else if (source === 'polymarket-wallets') {
      filterComponent = polymarketWalletsFilter();
    } else if (source === 'kalshi-items') {
      filterComponent = kalshiItemsFilter();
    } else if (source === 'kalshi-wallets' || source === 'kalshi-wallets-v20260315') {
      filterComponent = kalshiWalletsFilter();
    } else if (source === 'farcaster-users' || source === 'farcaster-profiles') {
      filterComponent = farcasterUsersFilter();
    } else if (source === 'token-items') {
      filterComponent = tokenItemsFilter();
    } else if (source === 'wallet-users') {
      filterComponent = walletUsersFilter();
    } else if (source === 'hyperliquid-wallets' || source === 'notification-hyperliquid-wallets') {
      filterComponent = notificationHyperliquidWalletsFilter();
    } else if (
      source === 'hyperliquid-wallet-positions' ||
      source === 'notification-hyperliquid-wallet-positions'
    ) {
      filterComponent = notificationHyperliquidPositionsFilter();
    } else if (
      source &&
      (source.startsWith('alpha-notifications-') ||
        source === 'dex-notifications' ||
        source === 'polymarket-notifications' ||
        source === 'hyperliquid-notifications')
    ) {
      filterComponent = alphaNotificationsFilter();
    } else if (
      source &&
      (source.startsWith('alpha-trade-events-') ||
        source === 'hyperliquid-trades' ||
        source === 'polymarket-trades' ||
        source === 'base-trades' ||
        source === 'ethereum-trades' ||
        source === 'solana-trades')
    ) {
      filterComponent = hyperliquidItemsFilter();
    } else if (source === 'hyperliquid-items') {
      filterComponent = hyperliquidMarketsFilter();
    }
  }


  const tooltip = getFilterTooltip(filterType, source);

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      {tooltip && (
        <Box sx={{ mb: 1.5 }}>
          <Tooltip
            title={
              <Typography component="span" sx={{ fontSize: '1rem', display: 'block', maxWidth: 420 }}>
                {tooltip}
              </Typography>
            }
            arrow
            placement="right"
          >
            <InfoOutlinedIcon fontSize="small" sx={{ color: 'action.active', cursor: 'help' }} />
          </Tooltip>
        </Box>
      )}
      {filterComponent}
    </Paper>
  );

};


export default FilterTypeRouter;
